@if (!uploading && !connectionFailed && !uploadSuccess) { @if (data$ | async; as data) {
<div class="container" [ngClass]="activeLanguage$ | async">
  <input type="file" #fileDropRef id="csvFile" (change)="fileBrowseHandler($event)" />
  <mat-icon class="upload" svgIcon="upload"></mat-icon>
  <h3 [innerHTML]="data.title"></h3>
  <label for="csvFile" [innerHTML]="data.shortDescription"></label>
</div>
} } @if (uploading && !connectionFailed) {
<div class="container uploading-status">
  <h3 [innerHTML]="'csvImport.uploading' | cxTranslate"></h3>
  @if (fileName.length <= 46) {
  <label [innerHTML]="fileName"></label>
  } @if (fileName.length > 46) {
  <app-tooltip-text
    class="has-tooltip"
    [tooltipContent]="fileName"
    [content]="fileName"
    placement="bottom"
  ></app-tooltip-text>
  }
</div>
} @if (!uploading && connectionFailed) {
<div class="container uploading-status status failed-container" (dragover)="resetUpload()">
  <h3 class="failed">
    {{ 'csvImport.failed' | cxTranslate }}&nbsp;
    <mat-icon>error</mat-icon>
  </h3>
  @if (!errorText) {
  <label [innerHTML]="'csvImport.failedSubtext' | cxTranslate"></label>
  } @if (errorText) {
  <label [innerHTML]="errorText"></label>
  }
  <button class="tertiary-btn btn" (click)="resetUpload()" [innerHTML]="'csvImport.retry' | cxTranslate"></button>
</div>
} @if (!uploading && uploadSuccess) {
<div class="container uploading-status upload-success status" (dragover)="resetUpload()">
  <h3 class="success"><mat-icon>check</mat-icon></h3>
  <h3 class="success" [innerHTML]="'csvImport.success' | cxTranslate"></h3>
  @if (fileName.length <= 46) {
  <label [innerHTML]="fileName"></label>
  } @if (fileName.length > 46) {
  <app-tooltip-text
    class="has-tooltip"
    [tooltipContent]="fileName"
    [content]="fileName"
    placement="bottom"
  ></app-tooltip-text>
  }
  <button
    class="tertiary-btn btn"
    [routerLink]="['/saved-cart']"
    [innerHTML]="'csvImport.viewSavedCart' | cxTranslate"
  ></button>
</div>
}
